var _path;
var _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgVector(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 12,
    height: 12,
    viewBox: "0 0 12 12",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M6.45405 6L11.9027 0.551351C12.0324 0.421621 12.0324 0.227027 11.9027 0.0972973C11.773 -0.0324324 11.5784 -0.0324324 11.4486 0.0972973L6 5.54595L0.551351 0.0972973C0.421621 -0.0324324 0.227027 -0.0324324 0.0972973 0.0972973C-0.0324324 0.227027 -0.0324324 0.421621 0.0972973 0.551351L5.54595 6L0.0972973 11.4486C-0.0324324 11.5784 -0.0324324 11.773 0.0972973 11.9027C0.162162 11.9676 0.259459 12 0.324324 12C0.389189 12 0.486486 11.9676 0.551351 11.9027L6 6.45405L11.4486 11.9027C11.5135 11.9676 11.6108 12 11.6757 12C11.7405 12 11.8378 11.9676 11.9027 11.9027C12.0324 11.773 12.0324 11.5784 11.9027 11.4486L6.45405 6Z",
    fill: "#E37617"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgVector);
export default __webpack_public_path__ + "static/media/Vector.90cf66b9806de11f2b23338b85b7fe2b.svg";
export { ForwardRef as ReactComponent };